// @flow

// Utils
import traverse from 'fc-utils/traverse'

// Constants
import { TREE, BRANCH } from 'hfty-model-supplies'

export default traverse([TREE, BRANCH], {default: {}})
